// src/services/auth.js

// Dynamically build the base API URL from your .env file
// const AUTH_API = `${process.env.REACT_APP_API_URL}/api/auth/`;
const AUTH_API = `${process.env.REACT_APP_API_URL}/api/`;


export const authService = {
    login: async (username, password) => {
        const response = await fetch(`${AUTH_API}login/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ username, password }),
        });

        if (!response.ok) {
            throw new Error('Login failed');
        }

        const data = await response.json();
        localStorage.setItem('token', data.token);
        localStorage.setItem('isAdmin', data.is_staff.toString());
        return data;
    },

    logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('isAdmin');
        window.location.href = '/';
    },

    isAdmin: () => {
        return localStorage.getItem('isAdmin') === 'true';
    },

    isAuthenticated: () => {
        return !!localStorage.getItem('token');
    }
};
